import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, ShoppingCart, User, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const Navbar = ({ cartCount, onSearch }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    const q = searchQuery.trim();
    if (q) {
      navigate(`/products?search=${encodeURIComponent(q)}`);
    }
  };

  return (
    <>
      {/* Top Announcement Bar */}
      <div className="bg-neutral-900 text-white text-center py-3 px-4 text-sm">
        <p>Free UK Shipping on Orders £69+ | 30-Day Returns</p>
      </div>

      {/* Main Navbar */}
      <nav className="bg-white border-b sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-neutral-900 rounded-full flex items-center justify-center">
                <span className="text-white font-light text-lg">F&C</span>
              </div>
              <div>
                <span className="text-xl font-light text-neutral-900 block">Freddy & Co.</span>
                <span className="text-xs text-neutral-500 hidden sm:block">Small Breed Specialists</span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/products?category=Fluff Essentials" className="text-neutral-700 hover:text-neutral-900 font-light transition-colors">
                Fluff Essentials
              </Link>

              <Link to="/products?category=Apparel" className="text-neutral-700 hover:text-neutral-900 font-light transition-colors">
                Apparel
              </Link>

              <Link to="/products?category=Owner Essentials" className="text-neutral-700 hover:text-neutral-900 font-light transition-colors">
                Owner Essentials
              </Link>

              <Link to="/products" className="text-neutral-700 hover:text-neutral-900 font-light transition-colors">
                All Products
              </Link>
            </div>

            {/* Search Bar */}
            <div className="hidden md:flex items-center flex-1 max-w-md mx-8">
              <form onSubmit={handleSearch} className="relative w-full">
                <Input
                  type="text"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-10 pr-4"
                />
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
              </form>
            </div>

            {/* Right Icons */}
            <div className="flex items-center space-x-4">
              <Button variant="ghost" size="icon" onClick={() => navigate('/cart')} className="relative">
                <ShoppingCart className="w-5 h-5" />
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-slate-900 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </Button>
              <Button variant="ghost" size="icon">
                <User className="w-5 h-5" />
              </Button>
              <Button
                variant="ghost"
                size="icon"
                className="md:hidden"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
              </Button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t bg-white">
            <div className="px-4 py-4 space-y-4">
              <form onSubmit={handleSearch} className="relative">
                <Input
                  type="text"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-10"
                />
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
              </form>
              <div className="space-y-2">
                <Link to="/products" className="block py-2 text-slate-700 hover:text-slate-900" onClick={() => setMobileMenuOpen(false)}>
                  All Products
                </Link>
                <Link to="/products?category=Pet Accessories" className="block py-2 text-slate-700 hover:text-slate-900" onClick={() => setMobileMenuOpen(false)}>
                  Pet Accessories
                </Link>
                <Link to="/products?category=Owner Accessories" className="block py-2 text-slate-700 hover:text-slate-900" onClick={() => setMobileMenuOpen(false)}>
                  Owner Accessories
                </Link>
                <Link to="/products?category=Clothing" className="block py-2 text-slate-700 hover:text-slate-900" onClick={() => setMobileMenuOpen(false)}>
                  Clothing
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
